module.exports = __webpack_public_path__ + "static/img/banner3.1f0bf7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner3.jpg
// module id = pwst
// module chunks = 1